import apiReminderBuilder from "../../../api";
import apiReminderTrigger from "../api";

const extract = (res, fallback = []) => (res.status === "fulfilled" ? res.value?.data?.data ?? fallback : fallback);

// Data of the trigger editor: sources and modules for the pickers, and the condition builder's operators, units and
// context dates.
export const loadTriggerDependencies = async () => {
  const [sourcesRes, modulesRes, operatorsRes, contextRes] = await Promise.allSettled([
    apiReminderBuilder.getSourceOptions(),
    apiReminderBuilder.getModuleKeys(),
    apiReminderTrigger.getOperators(),
    apiReminderTrigger.getContextKeys(),
  ]);
  const meta = extract(operatorsRes, {});
  return {
    sources: extract(sourcesRes),
    moduleKeys: extract(modulesRes),
    operators: meta.operators ?? [],
    units: meta.units ?? [],
    contextKeys: extract(contextRes),
  };
};

// Dropdown data of the list's advanced filter.
export const loadTriggerFilterDependencies = async () => {
  const [sourcesRes] = await Promise.allSettled([apiReminderBuilder.getSourceOptions()]);
  return { sources: extract(sourcesRes) };
};
